import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  AuthService,
  ClientService,
  IClient,
  IForgotPasswordDto,
  ToastService,
} from 'src/app/core';
import { CommonConstants } from 'src/app/shared/constant';
@Component({
  selector: 'ic-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  public formErrors: any = {};
  public clientConfig: IClient;
  public forgotPasswordForm: FormGroup;
  public selectedHelpType = CommonConstants.PasswordResetType.VerificationLink;
  public passwordResetType = CommonConstants.PasswordResetType;
  public token: string = '';

  constructor(
    private readonly fb: FormBuilder,
    private readonly clientService: ClientService,
    private readonly authService: AuthService,
    private readonly toastService: ToastService,
    public readonly activeDialog: NgbActiveModal
  ) {
    this.clientConfig = this.clientService.currentClientValue;
  }

  ngOnInit(): void {
    this.forgotPasswordForm = this.fb.group({
      email: [
        '',
        [Validators.required, Validators.maxLength(30), Validators.email],
      ],
      verificationCode: ['', [Validators.maxLength(30)]],
      password: ['', [Validators.maxLength(30)]],
      confirmPassword: ['', [Validators.maxLength(30)]],
    });

    Object.keys(this.forgotPasswordForm.controls).forEach((key) => {
      this.forgotPasswordForm.get(key).markAsTouched();
    });

    this.forgotPasswordForm.valueChanges.subscribe((changes) => {
      Object.keys(changes).forEach((controlName) => {
        const control = this.forgotPasswordForm.controls[controlName];
        this.formErrors[controlName] =
          (control.touched || control.dirty) && control.errors ? 'error' : null;
      });
    });
  }

  get fc() {
    return this.forgotPasswordForm.controls;
  }

  isNumber(evt: any) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    return true;
  }

  changeSelectedHelpType(type: number) {
    this.selectedHelpType = type;
  }

  onSubmit() {
    const model: IForgotPasswordDto = {
      ...this.forgotPasswordForm.value,
    };
    model.passwordResetType = this.selectedHelpType;
    model.restaurantId = this.clientConfig?.restaurantId;
    model.token = this.token;
    this.authService.forgotPassword(model).subscribe(
      (x) => {
        if (x.isSuccess) {
          if (this.selectedHelpType === this.passwordResetType.ResetPassword) {
            this.toastService.showSuccess('Password changed successfully!');
            this.closeDialog();
          } else if (
            this.selectedHelpType === this.passwordResetType.VerificationLink
          ) {
            this.toastService.showSuccess(
              'Email verification link sent successfully!'
            );
            this.closeDialog();
          } else if (
            this.selectedHelpType === this.passwordResetType.VerificationCode
          ) {
            this.token = x.responses[0];
            this.selectedHelpType = this.passwordResetType.ResetPassword;

            this.forgotPasswordForm.get('email').clearValidators();
            this.forgotPasswordForm.get('email').updateValueAndValidity();

            this.forgotPasswordForm
              .get('verificationCode')
              .setValidators([Validators.required]);
            this.forgotPasswordForm
              .get('verificationCode')
              .updateValueAndValidity();

            this.forgotPasswordForm
              .get('password')
              .setValidators([Validators.required]);
            this.forgotPasswordForm.get('password').updateValueAndValidity();

            this.forgotPasswordForm
              .get('confirmPassword')
              .setValidators([Validators.required]);
            this.forgotPasswordForm
              .get('confirmPassword')
              .updateValueAndValidity();
          }
        } else {
          this.toastService.showError(x.errors[0]);
        }
      },
      (err) => {
        this.toastService.showError(err.exceptionMessage || err.message);
      }
    );
  }

  trimEmail() {
    const val = this.forgotPasswordForm.get('email').value.trim();
    this.forgotPasswordForm.get('email').setValue(val);
  }

  closeDialog() {
    this.activeDialog.close();
  }
}
